module.exports = __webpack_public_path__ + "img/dashboard.e9cf49d8.svg";